import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { authwsEnvironment } from './authws-environment';
import { accountsSchema } from './schemas/accounts.schema';

export function getPartnerAccounts(partnerId: string) {
  const query = `partnerId=${encodeURIComponent(partnerId)}`;
  return fromFetch(
    new Request(`${authwsEnvironment.partnerAccountsUrl}?${query}`, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
    })
  ).pipe(selectData(accountsSchema));
}
